module.exports = __webpack_public_path__ + "static/media/Tip.a7d162ea.svg";